import { useState, useCallback } from 'react'
import useServiceLabelsResources from '../../shared/resources/api/v1/admin/docker/useServiceLabelsResources'

export default function useServiceLabelsState(teamSlug, projectSlug, serviceSlug) {
  const [labels, setLabels] = useState([])
  const [loading, setLoading] = useState(true)

  const {
    all,
    create,
    update,
    destroy,
  } = useServiceLabelsResources(teamSlug, projectSlug, serviceSlug)

  const load = useCallback(() => {
    return all()
      .then((response) => setLabels(response.serviceLabels || []))
      .catch(() => setLabels([]))
      .finally(() => setLoading(false))
  }, [all])

  const refresh = useCallback(() => {
    return all()
      .then((response) => setLabels(response.serviceLabels || []))
      .catch(() => setLabels([]))
  }, [all])

  const createLabel = useCallback((data) => {
    return create(data).then(() => refresh())
  }, [create, refresh])

  const updateLabel = useCallback((id, data) => {
    return update(id, data).then(() => refresh())
  }, [update, refresh])

  const destroyLabel = useCallback((id) => {
    return destroy(id).then(() => refresh())
  }, [destroy, refresh])

  return {
    labels,
    loading,
    load,
    createLabel,
    updateLabel,
    destroyLabel,
  }
}
